const ITEMS = [
  "STAGE 1 OPTIMISATION",
  "CLONAGE CALCULATEUR",
  "DÉSACTIVATION EGR FAP ADBLUE",
  "RÉPARATION ANTI-DÉMARRAGE IMMO",
  "CLONAGE & RÉPARATION TCU BOÎTE AUTO",
  "CALCULATEUR AIRBAG & CRASH DATA",
  "RÉPARATION COMPTEURS",
  "TEST SUR BANC AVANT EXPÉDITION",
];

const Track = () => (
  <div className="flex items-center gap-12 pr-12">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center gap-12">
        <span>{item}</span>
        <span className="text-[#51ADDA]">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="py-5 border-b border-[#1C2C4E] bg-[#0A1628] overflow-hidden font-display text-2xl uppercase tracking-wider text-slate-400">
    <div className="mq-track">
      <Track />
      <Track />
    </div>
  </div>
);
